// SignupForm.js
import React, { useEffect } from 'react';
import { loadOutseta } from '../Outseta';

const SignupForm = () => {
    const OPTIONS = {
        domain: "lifetab.outseta.com",
        load: "auth",
        auth: {
          widgetMode: "register",
          planUid: "7maO3G9E", // Standard Plan
          planPaymentTerm: "month",
          skipPlanOptions: false,
          id: "signup_embed",
          mode: "embed",
          selector: "#outseta-signup-form"
        }
    };

    useEffect(() => {
        loadOutseta(OPTIONS);
    }, []);

    return (
        <div id="outseta-signup-form-wrapper">
            <div id="outseta-signup-form"><h3 style={{textAlign: 'center'}}>Loading ... kindly wait.</h3></div>
            <div className='flex justify-content-center gap-[5px] font-inter'><span className='opacity-50'>Already have an account?</span> <a href="/login">Log In</a></div>
        </div>
    );
};

export default SignupForm;
